import React from 'react';
import HelmetBuilder from '../components/helmet-builder';
import CollaborationsHero from '../components/collaborations-hero';
import CollaborationsMain from '../components/collaborations-main';
import CollaborationsCloser from '../components/collaborations-closer';
//import OurPartners from '../components/our-partners';

import './collaborations.scss';

const IndexPage = ({ data, location }) =>
    <div className="collaborations">
        <HelmetBuilder data={data.collaborations.edges[0].node} pathname={location.pathname} />
        <CollaborationsHero data={data.collaborations.edges[0].node} />
        <CollaborationsMain data={data.collaborations.edges[0].node} />
        <CollaborationsCloser data={data.collaborations.edges[0].node} />
    </div>;

// <OurPartners data={data.collaborations.edges[0].node} /> //was under CollaborationsCloser

export default IndexPage;

export const pageQuery = graphql`
    query CollaborationsPage {
        collaborations: allContentfulCollaborationsPage {
            edges {
                node {
                    metadata {
                        title
                        description
                        ogimage {
                            file {
                                url
                            }
                        }
                        keywords
                    }
                    heroHeading
                    heroText {
                        heroText
                    }
                    heroUrl
                    heroCallToActionText
                    mainHeading
                    mainHeadingLineTwo
                    mainImage {
                        file {
                            url
                        }
                    }
                    mainText {
                        mainText
                    }
                    mainUrl
                    mainCallToActionText
                    secondHeading
                    secondHeadingLineTwo
                    secondImage {
                        file {
                            url
                        }
                    }
                    secondText {
                        secondText
                    }
                    secondUrl
                    secondCallToActionText
                    partnersLogos {
                        id
                        file {
                            url
                        }
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/collaborations.js